<template>
  <div class="'animate__animated animate__fadeIn">
    <iframe
      :src="fileBase64"
      width="100%"
      height="770px"
      frameborder="0"
    ></iframe>
    <div class="button-group mt-3">
      <div>
        <el-button
          type="info"
          plain
          @click="goBack"
        >
          Quay lại
        </el-button>
      </div>
      <div class="mr-3">
        <el-button
          plain
          type="danger"
          @click="openDialog('refuse')"
        >
          Từ chối
        </el-button>
        <el-button
          plain
          type="primary"
          @click="openDialog('signApproval')"
        >
          Ký duyệt
        </el-button>
      </div>
    </div>
    <el-dialog
      class="dialog-sign-approval"
      :visible.sync="dialogVisible"
      width="550px"
      :top="typeDialog == 'refuse' ? '6%' : '10%'"
      :before-close="dialogBeforeClose"
      :destroy-on-close="true"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div class="text-center">
        <div class="icon-image">
          <el-image
            :src="typeDialog == 'signApproval' ? 'img/Confirmation.png' : 'img/Confirmation_question-mark.png'"
            fit="cover"
          ></el-image>
        </div>
        <p class="title-notification">
          Xác nhận
          {{typeDialog == 'signApproval' ? 'Ký duyệt' : 'Từ chối ký duyệt'}}
          văn bản</p>
        <p class="title-notification">"{{dataForm.name}}"</p>
        <div class="reason-refuse mt-3" v-if="typeDialog == 'refuse'">
          <el-form
            ref="reasonForm"
            :model="reason"
            :rules="validForm"
          >
            <el-form-item label="Lý do từ chối" prop="note">
              <el-input
                type="textarea"
                v-model="reason.note"
                :autosize="{ minRows: 5, maxRows: 10}"
                @change="() => {reason.note = reason.note.trim()}"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="button-group mt-3">
          <el-button
            plain
            type="info"
            @click="dialogBeforeClose"
          >
            Đóng
          </el-button>
          <el-button
            v-if="typeDialog == 'signApproval'"
            plain
            type="primary"
            @click="signApprovalDocument"
          >
            Xác nhận ký
          </el-button>
          <el-button
            v-if="typeDialog == 'refuse'"
            plain
            type="danger"
            @click="refuseDocument"
          >
            Từ chối ký duyệt
          </el-button>
        </div>
      </div>
    </el-dialog>
    <Loading v-if="loading" />
  </div>
</template>
<script>
import ExtensionService from '../../../../service/ExtensionService';
import MethodService from '../../../../service/MethodService';
import ValidService from '../../../../service/ValidService';
import DraffDocumentAutoModel from './DraffDocumentAutoModel';
import DraffDocumentAutoApi from '@/moduleApi/DraffDocumentAutoApi';
import toastr from 'toastr';
import Loading from "@/component/Loading";
export default {
  components: {
    Loading,
  },
  data() {
    return {
      ExtensionService,
      moduleName: 'DocumentDrafting',
      havePdfFile: false,
      pdfId: undefined,
      fileBase64: undefined,
      dataForm: MethodService.copyObject(DraffDocumentAutoModel.dataForm),
      currentUser: MethodService.getCurrentUser(),
      dialogVisible: false,
      typeDialog: '',
      reason: {
        note: undefined,
      },
      validForm: {
        note: [ValidService.required]
      },
      loading: true
    };
  },
  methods: {
    async getDataById(id) {
      this.loading = true;
      const apiRes = await DraffDocumentAutoApi.findById(id);
      const pdfPreview = await DraffDocumentAutoApi.ViewSignOnPdf({
        dda_id: id
      });
      if (apiRes.result) {
        this.dataForm = apiRes.result;
        if (pdfPreview.result && pdfPreview.result.fileBase64 != "") {
          this.fileBase64 = 'data:application/pdf;base64, ' + pdfPreview.result.fileBase64;
        } else {
          if (this.dataForm.unsigned_pdf_id || this.dataForm.signed_pdf_id) {
            this.fileBase64 = ExtensionService.urlImg + (this.dataForm.signed_pdf_id ? this.dataForm.signed_pdf_id : this.dataForm.unsigned_pdf_id);
          }
        }
        let checkInside = (this.dataForm.readers || []).find(item => item.employee_id == this.currentUser.id)
        if (!checkInside) {
          if (!this.dataForm.readers) this.dataForm.readers = []
          this.dataForm.readers.push({
            employee_id: this.currentUser.id,
            read_at: new Date()
          })
          this.updateReaders(this.dataForm)
        }
      }
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    updateReaders(dataForm) {
      try {
        DraffDocumentAutoApi.update(dataForm)
      } catch (error) {
        toastr.error('Có lỗi xảy ra, vui lòng thử lại!')
      }
    },
    openDialog(type) {
      this.typeDialog = type;
      this.dialogVisible = true;
    },
    async signApprovalDocument() {
      try {
        const apiRes = await DraffDocumentAutoApi.SignForApproval(this.dataForm.id);
        if (apiRes.result) {
          toastr.success('Ký duyệt thành công');
          this.$router.push({ name: 'Admin-DocumentDrafting-list' }).catch((err) => {});
        }
      } catch (error) {
        if (error.detail) {
          if (error.code == 401) {
                toastr.error('Chờ tới lượt bạn ký hợp đồng này');
              } else {
                toastr.error(error.detail);
              }
        } else {
          toastr.error("Ký duyệt không thành công, vui lòng thử lại!");
        }
      }
    },
    async refuseDocument() {
      this.$refs['reasonForm'].validate(async (valid) => {
        if (valid) {
          let data = {
            dda_id: this.dataForm.id,
            note: this.reason.note
          }
          try {
            const apiRes = await DraffDocumentAutoApi.SignForReject(data);
            if (apiRes.result) {
              toastr.success('Từ chối ký duyệt thành công');
              this.$router.push({ name: 'Admin-DocumentDrafting-list' }).catch((err) => {});
            }
          } catch (error) {
            if (error.detail) {
              if (error.code == 401) {
                toastr.error('Chờ tới lượt bạn ký hợp đồng này');
              } else {
                toastr.error(error.detail);
              }
            } else {
              toastr.error("Từ chối duyệt không thành công, vui lòng thử lại!");
            }
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      })
    },
    dialogBeforeClose(){
      this.dialogVisible = false;
      this.reason.note = undefined;
    },
    goBack() {
      this.$router.push({ name: 'Admin-DocumentDrafting-list' }).catch((err) => {});
    }
  },
  created() {
    if (this.$route.params.id) {
      this.getDataById(this.$route.params.id);
    }
  }
}
</script>
<style lang="scss" scoped>
iframe {
  height: calc(100vh - 160px);
}
.button-group {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
::v-deep .dialog-sign-approval {
  .el-dialog {
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 40px 50px 28px 50px;
      .title-notification {
        font-family: 'LexendDeca Regular';
        font-weight: 300;
        font-size: 20px;
        line-height: 32px;
      }
      .reason-refuse {
        .el-form-item__label {
          margin-bottom: 0;
        }
      }
    }
  }
}

</style>
